import { ReactElement } from 'react';

import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { translationKeys } from '../translations';

type WaitlistAddEntryActionProps = {
   onClick: VoidFunction;
};

export const WaitlistAddEntryAction = (props: WaitlistAddEntryActionProps): ReactElement => {
   return (
      <ActionBar.PrimaryButton
         testId={'addEntry'}
         label={translationKeys.addEntry}
         onClick={props.onClick}
         variant={ButtonVariant.PRIMARY}
      />
   );
};
